import { useIntl } from 'react-intl';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { Header, NavBar, headerNavigationRegistration } from '@marketplace/common';
import { Logo } from '@marketplace/ui-elements';
import { New_footer as SimpleFooter } from '../../pages/layouts/landing-layout/footer/footer';
import { RegistrationForm } from './registration-form';
import { useAPICreateDeveloper, ERROR_CODES } from '@marketplace/api';
import { RegistrationFormComplete, TRegistrationFormState } from './registration.types';
import classes from './registration.module.scss';

export const Registration = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const formRef = useRef<HTMLFormElement>(null);
  const [status, setStatus] = useState(false);
  const [redirectUrl,setRedirectUrl]= useState('');
  const [createDeveloperResponse, setCreateDeveloperResponse] = useState({});
  const {
    loading: createDeveloperLoading,
    loaded: createDeveloperLoaded,
    createDeveloper,
    data: createDeveloperData,
  } = useAPICreateDeveloper();
  const history = useHistory();

  const [modalState, setModalState] = useState<TRegistrationFormState>({
    registrationForm: {
      email: '',
      firstName: '',
      lastName: '',
      dial_country_id: undefined,
      phone: '',
      city: '',
      companyName: '',
      country: undefined,
      state: undefined,
      postalCode: '',
      agree: false,
      address: '',
    },
  });

  useEffect(() => {
    if (createDeveloperData?.errors && (createDeveloperData?.errors[0]?.code === ERROR_CODES.EMAIL_ALREADY_EXTSTS_IN_BOTH_GIS_AND_DP_DATABASE || 
      createDeveloperData?.errors[0]?.code === ERROR_CODES.EMAIL_ALREADY_EXTSTS_IN_GIS_DATABASE_NOT_IN_DP_DATABASE ||
      createDeveloperData?.errors[0]?.code === ERROR_CODES.EMAIL_ALREADY_EXTSTS_IN_DP_DATABASE_NOT_IN_GIS_DATABASE)
    ) {
      setCreateDeveloperResponse(createDeveloperData);
      triggerSubmitForm();
    }

    // handle submit form
    if (createDeveloperLoaded) {
      setRedirectUrl(createDeveloperData?.data?.registrationLink);
      setStatus(createDeveloperLoaded);
    }
  }, [createDeveloperData, createDeveloperLoaded]);

  const triggerSubmitForm = (): void => {
    formRef.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  };

  const handleSubmitForm = () => {
    createDeveloper({
      first_name: modalState.registrationForm.firstName.trim(),
      last_name: modalState.registrationForm.lastName.trim(),
      email: modalState.registrationForm.email.trim(),
      dial_country_id: (modalState.registrationForm.dial_country_id?.id || '').trim(),
      phone_number: modalState.registrationForm.phone.trim(),
      company_name: modalState.registrationForm.companyName.trim(),
      country: (modalState.registrationForm.country?.key || '').trim(),
      city: modalState.registrationForm.city.trim(),
      state: (modalState.registrationForm.state?.key || '').trim(),
      postal_code: modalState.registrationForm.postalCode.trim(),
      address: modalState.registrationForm?.address?.trim(),
    });
  };

  const handleChangeForm = (
    formName: RegistrationFormComplete.REGISTRATION_FORM,
    fields: { [key: string]: any }
  ): void => {
    setModalState((prevState) => ({
      ...prevState,
      [formName]: {
        ...prevState[formName],
        ...fields,
      },
    }));
  };

  const redirectToGIS = (url:string) => {
    if (url && url.length > 0) {
      window.location.href= url;
    }
  }

  const formProps = {
    formRef,
    hidden: false,
    initialValues: modalState['registrationForm'],
    onChange: handleChangeForm,
    onSubmit: handleSubmitForm,
    isAcceptDisable: false,
    acceptLabel: 'Submit',
    clearLabel: 'Clear',
    onAccept:(()=>{
      setCreateDeveloperResponse({})
      triggerSubmitForm()
    }),
    isLoading: createDeveloperLoading,
    submitResponseData:createDeveloperResponse,
  };

  return (
    <div className={classes.registrationRoot}>
      <Header
        logo={<Logo subLogo={formatMessage({ id: 'developer_landing_header_sub_logo' })} />}
        leftSection={<NavBar options={headerNavigationRegistration} />}
      />
      <div className={classes.registrationForm}>
        <RegistrationForm {...formProps} />
        {status === createDeveloperLoaded ? redirectToGIS(redirectUrl) : null}
      </div>
      <div className={classes.registrationFooter}>
        <SimpleFooter />
      </div>
    </div>
  );
};
